import './style.scss';

import React from 'react';
import { connect } from 'react-redux';
import * as actions from './actions';
import { url as productUrl } from 'shared/models/product';
import IsolatedScroll from 'react-isolated-scroll';
import Autosuggest from 'react-autosuggest';

class Search extends React.Component {
  constructor(props) {
    super(props);
    this.state = { userInput: '' };
    this.search = this.search.bind(this);
    this.onSuggestionsFetchRequested = this.onSuggestionsFetchRequested.bind(
      this
    );
    this.onSuggestionsClearRequested = this.noop.bind(this);
    this.getSuggestionValue = this.getSuggestionValue.bind(this);
    this.renderSuggestion = this.renderSuggestion.bind(this);
    this.onSuggestionSelected = this.onSuggestionSelected.bind(this);
    this.renderSuggestionsContainer = this.renderSuggestionsContainer.bind(
      this
    );
  }

  render() {
    this.inputProps = {
      placeholder: 'What can we help you find?',
      value: this.props.value,
      onChange: this.onChange.bind(this),
      className: 'search-query'
    };
    return (
      <div id="search">
        <form onSubmit={this.search}>
          <span className="icon-search" />
          <Autosuggest
            suggestions={this.props.suggestions}
            onSuggestionsFetchRequested={this.onSuggestionsFetchRequested}
            onSuggestionsClearRequested={this.onSuggestionsClearRequested}
            getSuggestionValue={this.getSuggestionValue}
            renderSuggestion={this.renderSuggestion}
            inputProps={this.inputProps}
            onSuggestionSelected={this.onSuggestionSelected}
            focusInputOnSuggestionClick={false}
            renderSuggestionsContainer={this.renderSuggestionsContainer}
          />
        </form>
      </div>
    );
  }

  renderSuggestion(item, { isHighlighted }) {
    return item.recommendationType === 'product'
      ? this.renderSuggestedProduct(item, isHighlighted)
      : this.renderSuggestedCategory(item, isHighlighted);
  }

  renderSuggestedCategory(item, isHighlighted) {
    return (
      <div
        className={`search-item search-item--category ${isHighlighted
          ? 'search-item--highlighted'
          : ''}`}
      >
        <div className="search-item-label">
          <span className="search-item-title text-title">{item.value}</span>
          <span>(Browse All)</span>
        </div>
      </div>
    );
  }

  renderSuggestedProduct(item, isHighlighted) {
    let style = item.image
      ? { backgroundImage: 'url(' + item.image + ')' }
      : {};
    return (
      <div
        className={`search-item ${isHighlighted
          ? 'search-item--highlighted'
          : ''}`}
      >
        <span className="search-item-image" style={style} />
        <div className="search-item-label">
          <span className="search-item-title text-title">{item.title}</span>
          <span className="search-item-subtitle">{item.subtitle}</span>
        </div>
        <div className="search-item-info">
          {item.price && (
            <span className="search-item-price text-title">
              ${item.priceDisplay}
            </span>
          )}
          <span className="search-item-volume">{item.volume}</span>
        </div>
      </div>
    );
  }

  renderSuggestionsContainer({ containerProps, children }) {
    const { ref, ...restContainerProps } = containerProps;
    const callRef = isolatedScroll => {
      if (isolatedScroll !== null) {
        ref(isolatedScroll.component);
      }
    };
    return (
      <IsolatedScroll ref={callRef} {...restContainerProps}>
        {children}
      </IsolatedScroll>
    );
  }

  getSuggestionValue(item) {
    return item.recommendationType === 'product' ? item.title : item.value;
  }

  search(event) {
    event.preventDefault();
    if (this.props.value && this.props.value === this.state.userInput) {
      window.location = `/search/${encodeURIComponent(this.props.value)}`;
    }
  }

  onChange(event, { newValue, method }) {
    if (method === 'type') this.setState({ userInput: newValue });
    if (newValue.trim() == '') return this.props.clearSuggestion();
    this.props.updateInput(newValue);
  }

  onSuggestionsFetchRequested({ value }) {
    this.props.autocomplete(value, this.props.address);
  }

  onSuggestionSelected(event, { suggestion }) {
    let url =
      suggestion.recommendationType === 'product'
        ? productUrl(suggestion)
        : this.categoryUrl(suggestion);
    if (url && url.indexOf('/') !== 0) url = '/' + url;
    if (url) window.location = url;
  }

  categoryUrl(suggestion) {
    return suggestion.kind === 'category'
      ? `/${suggestion.category_url}`
      : `/${suggestion.category_url}?${encodeURIComponent(
          suggestion.kind
        )}=${encodeURIComponent(suggestion.value)}`;
  }

  noop() {}
}

function mapStateToProps(state) {
  return { ...state.search, address: state.address.location };
}

export default connect(mapStateToProps, { ...actions })(Search);



// WEBPACK FOOTER //
// ./shared/components/search/index.js